import { Module } from 'wrapper6'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

const $ = jQuery

export default class ProductTooltip extends Module {
  ready (app) {
    this.tooltips = document.querySelectorAll('.image-dot')

    if (this.tooltips.length) {
      for (let i = 0; i < this.tooltips.length; i++) {
        const tooltip = this.tooltips[i]
        const image = tooltip.getAttribute('data-image') ? tooltip.getAttribute('data-image') : ''
        const title = tooltip.getAttribute('data-title') ? tooltip.getAttribute('data-title') : ''
        const text = tooltip.getAttribute('data-text') ? tooltip.getAttribute('data-text') : ''
        const link = tooltip.getAttribute('data-link') ? tooltip.getAttribute('data-link') : ''

        const content =
        '<div class="tooltip-image">' +
          '<div class="image"> <img src="' + image + '" alt="produkt"> </div>' +
          '<div class="text-wrapper">' +
            '<div class="title">' + title + '</div>' +
            '<div class="text">' + text + '</div>' +
            '<a class="mtt-link-text" href="' + link + '"> Se produkt </a>' +
          '</div>' +
        '</div>'

        tippy(tooltip, {
          content: content,
          trigger: 'click',
          theme: 'tooltip',
          placement: 'bottom',
          interactive: true,
          allowHTML: true,
          maxWidth: 400
        })
      }
    }
  }
}
